module.exports = __webpack_public_path__ + "img/PXL_20230523_145119889.fe8b18e3.jpg";